module.exports = __webpack_public_path__ + "img/3.34cd4cd3.png";